@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="opening-step" #openingStep [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h1>{{ 'landing-page.step_1.hook' | translate }}</h1>
    <h2>{{ 'landing-page.step_1.baseline' | translate }}</h2>
    <app-button type="get-stared" (click)="getStartedClick.emit()" >{{ 'common.get_started' | translate }}</app-button>
    <lucide-angular size="32" name="arrowDown" (click)="arrowClick.emit()"></lucide-angular>


    <div class="noise"></div>
    <div #circle class="circle"></div>
    <div class="gradient"></div>
</div>